export function setClientes(state, clientes) {
    state.clientes = clientes
}

export function actListClientes(state, cliente) {
    if (cliente !== null) {
        const index = state.clientes.findIndex(r => r.id === cliente.id)
        if (index != -1) {
            state.clientes.splice(index, 1, cliente)   
        }
    }
  
}

export function actDeleteListClientes(state, id) {
    if (id != null) {
        const index = state.clientes.findIndex(r => r.id === id)
        if (index != -1) {
            state.clientes.splice(index, 1)
        }
    }
}



export function setClienteSelec(state, cliente) {
    state.clienteSelec = cliente
}




